


























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Collapse, CollapseItem, Switch, Cell, CellGroup, Checkbox, CheckboxGroup, Popup, Picker } from "vant";
import axios from "axios";
import HotelPolicyService from "@/service/hotelPolicyService";
import SystemService from "@/service/UserService";
import * as _ from "lodash";
import { FlightProductEntity, FlightGoodsEntity } from "../../../model/FlightPolicy";
import { DurationTime } from "@/utils/utils.ts";
import { RoleInfoEntity } from "../../../model/system";
// import orderFrame from "./hotelOrderFrame";
import orderFrame from "../orderFrame.vue";
import { HotelPolicyEntity } from "@/model/hotel";
import { PriceType, ServiceType } from "@/model/Base";

@Component({
  name: "hotelOrder",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    orderFrame,
  },
  filters: {
    DurationTime,
  },
})
export default class extends Vue {
  Products = [];
  // policys = [];
  Goods = {};
  // @Prop()
  // model: any;

  // @Prop()
  // consumers!: RoleInfoEntity[];

  policys: HotelPolicyEntity[] = [];

  get ServiceType() {
    return ServiceType.HotelService;
  }
  get ProductId() {
    return this.$route.query.ProductId;
  }
  get DepartDate() {
    return this.$route.query.DepartDate;
  }
  get ArriveDate() {
    return this.$route.query.ArriveDate;
  }
  defaultImg = 'this.src="' + require("../../../../static/img/errHotelImg.png") + '"';

  infoIcon = require("../../../../static/img/info.png");
  warringIcon = require("../../../../static/img/warring.png");
  isRequestOver = false;

  mounted() {
    this.getInfoData();
  }

  //methods
  getInfoData() {
    const query = this.$route.query;
    const data: object = {
      ProductID: query.ProductId,
      BookingType: 1529,
      ApplyArea: 1126,
      ServiceType: 1407,
      TicketDelivery: 1450,
      RoomNum: 1,
      Extras: [{ ServiceType: 1466, ThrowID: "" }],
      ContactEmailNotify: false,
      ProduceID: query.ThrowID,
      ThrowId: query.ThrowID,
      ArrivalDate: this.ArriveDate,
      DepartureDate: this.DepartDate,
      PolicyID: query.PolicyID,
    };

    HotelPolicyService.getProductInfo(data).then(res => {
      if (res.isSucc && res.result) {
        this.isRequestOver = true;
        const policys = res.result as any;
        this.policys = policys;
        this.Products = policys[0].Products!;
        this.Goods = policys[0].Goods![0];
      }
    });
  }

  getProductImg(path: string): string {
    const imgPath = path.split(",");
    return imgPath[0];
  }

  totalPrices(typeCode: string): number {
    let sumPrice = 0;
    for (let i = 0; i < this.policys.length; i++) {
      const policy = this.policys[i];
      const goods = (policy as any).Goods[0] as FlightGoodsEntity;
      for (let p = 0; p < goods.Prices!.length; p++) {
        const price = goods.Prices![p];
        if (price.PriceType == PriceType.HotelFare || price.PriceType==PriceType.DirectReduction) {
          sumPrice += price.MarketPrice;
        }
      }
    }
    return sumPrice;
  }

  extractExtra(code: string, policys?: any) {
    if (!policys || !policys[0] || !policys[0]) {
      return "";
    }
    let rule = _.find(policys[0].Products[0].Extras, item => item.ExtraCode == code);
    if (rule && rule.ExtraData) {
      return rule.ExtraData;
    }
  }
  formatDate(value: Date, format: string = this.$root.$t("mall_hotel_hotelorder_yueri") as string) {
    return (this as any).$moment(value).format(format);
  }
  resetProductName(productName: string){
    if (!productName) {
      return { name: '', hasHuazhu: false };
    }
    const regex = /\(华住\)/g;
    const hasHuazhu = regex.test(productName);
    const processedName = productName.replace(regex, '');

    return { 
      name: processedName, // 处理后的酒店名称
      hasHuazhu: hasHuazhu // 是否包含华住标识
    };
  }
  getAssetsFile(fileName: string) {
    return require(`@/assets/hotel-icon/${fileName}.png`);
  }
}
